import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

interface VideoInfoProps {
  title: string;
  description: string;
  views: number;
  date: string;
  duration: string;
  category: string;
  tags: string[];
  source: string;
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
}

export default function VideoInfo({
  title,
  description,
  views,
  date,
  duration,
  category,
  tags,
  source,
}: VideoInfoProps) {
  const cat = categories.find((c) => c.slug === category);

  return (
    <div>
      <div className="flex flex-wrap items-center gap-2 mb-3">
        {cat && (
          <Link
            to={`/category/${cat.slug}`}
            className="flex items-center gap-1 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium hover:bg-primary-200 transition-colors cursor-pointer"
          >
            <i className={`${cat.icon} text-xs`}></i>
            {cat.name}
          </Link>
        )}
        <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
          独家爆料
        </span>
      </div>

      <h1 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight mb-4">
        {title}
      </h1>

      <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500 mb-5">
        <span className="flex items-center gap-1.5">
          <i className="ri-eye-line text-foreground-400"></i>
          <strong className="text-primary-600 font-semibold">{formatViews(views)}</strong> 次播放
        </span>
        <span className="flex items-center gap-1.5">
          <i className="ri-time-line text-foreground-400"></i>
          {duration}
        </span>
        <span className="flex items-center gap-1.5">
          <i className="ri-calendar-line text-foreground-400"></i>
          {date}
        </span>
        <span className="flex items-center gap-1.5">
          <i className="ri-user-voice-line text-foreground-400"></i>
          来源：{source}
        </span>
      </div>

      <div className="prose prose-sm max-w-none">
        <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
          {description}
        </p>
        <p className="text-foreground-500 leading-relaxed text-sm mt-3">
          本视频为吃瓜视频平台独家爆料内容。网红翻车、明星八卦、热门爆料每日更新，免费吃瓜视频在线观看。更多精彩吃瓜视频，请持续关注吃瓜视频平台，吃瓜吃到饱！
        </p>
      </div>

      <div className="flex flex-wrap gap-2 mt-5">
        {tags.map((tag) => (
          <span
            key={tag}
            className="px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium"
          >
            #{tag}
          </span>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mt-6 pt-6 border-t border-background-200">
        <button className="flex items-center justify-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-download-2-line"></i>
          下载高清视频
        </button>
        <button className="flex items-center justify-center gap-2 px-5 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-share-forward-line"></i>
          分享给瓜友
        </button>
        <button className="flex items-center justify-center gap-2 px-5 py-2.5 bg-background-100 text-foreground-700 rounded-full text-sm font-medium hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">
          <i className="ri-bookmark-line"></i>
          收藏吃瓜
        </button>
      </div>
    </div>
  );
}